import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/Tooltip';
import { getFormattedUsername } from '@/lib/utils';
import { Crm } from '@/services/CrmService';

interface UsernameProps {
  crm: Pick<Crm, 'name' | 'email' | 'userProfileId'>;
}

export function Username({ crm }: UsernameProps) {
  const username = getFormattedUsername(
    crm?.name,
    crm?.email,
    crm?.userProfileId,
  ).displayName;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <h3 className="max-w-[240px] truncate text-2xl font-normal">
            {username}
          </h3>
        </TooltipTrigger>

        <TooltipContent className="bg-gray-900 p-4">
          <span>{username}</span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
